import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import cyclesVsDemand from "@/assets/cycles-vs-demand-optimized.jpg";
import TitleAccent from "@/components/TitleAccent";

const RhythmSection = () => {
  const { t } = useTranslation();
  return (
    <section id="rhythm" className="bg-background">
      <div className="grid lg:grid-cols-2 items-stretch">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="order-1 min-h-[400px] lg:min-h-0"
        >
          <img
            src={cyclesVsDemand}
            alt="Nature cycles versus urban demand — the energy tension"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            sizes="(min-width: 1024px) 50vw, 100vw"
            className="w-full h-full object-cover"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="order-2 flex flex-col justify-center px-8 md:px-16 lg:pl-16 lg:pr-0 py-16 lg:py-24 lg:max-w-[36rem]"
        >
          <p className="text-muted-foreground text-xs lg:text-sm font-display font-semibold tracking-[0.3em] lg:tracking-[0.35em] uppercase mb-6">
            {t("rhythm.eyebrow")}
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-[1.1] mb-5">
            {t("rhythm.title1")}
            <br />
            {t("rhythm.title2")}
          </h2>
          <TitleAccent className="mb-10" />

          <div className="space-y-6 max-w-lg">
            <p className="text-body">{t("rhythm.body")}</p>
            <p className="text-supporting">{t("rhythm.butOps")}</p>
            <ul className="space-y-3">
              {["bullet1", "bullet2", "bullet3"].map((key) => (
                <li key={key} className="flex items-start gap-3">
                  <span className="w-1 h-1 rounded-full bg-foreground mt-2.5 shrink-0" />
                  <span className="text-bullet">{t(`rhythm.${key}`)}</span>
                </li>
              ))}
            </ul>
            <p className="text-supporting">{t("rhythm.closing")}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RhythmSection;
